import css from "../../css/common/modal.module.css";
import cssModal from "../../css/listing/modal.module.css";
import formCss from "../../css/form/request.module.css";

import React, { useState } from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import * as Yup from "yup";
import classNames from "classnames";
import { withFormik, Field, ErrorMessage } from "formik";
import { getFormErrors } from "../../service/formik-form";
import {
    shareListing,
    shareProperty,
    shareLink,
} from "../../service/share-home";
import clone from "../../helper/clone";
import Logo from "../header/Logo";
import moneyFormatter from "../../helper/moneyFormatter";
import { toastError, toastInfo } from "../ToastNotification";
import CloseIcon from "mdi-react/CloseIcon";

const ValidationSchema = Yup.object().shape({
    recipient_emails: Yup.string().label("Email").required("Required").max(500),
    sender_email: Yup.string()
        .email("Invalid email")
        .label("Email")
        .required("Required")
        .max(250),
    message: Yup.string().label("Reply").max(1000),
});

const Share = (props) => {
    const { listing, property, onClose, handleSubmit, values, isSubmitting } =
        props;

    const [isCopied, setIsCopied] = useState(false);

    const clipboardItemWrite = () => {
        if (typeof ClipboardItem === "undefined") {
            return null;
        }

        return new ClipboardItem({
            "text/plain": shareLink(listing, property).then((r) => {
                const copyText = window.location.href;

                return new Promise(async (resolve) => {
                    resolve(new Blob([copyText]));
                });
            }),
        });
    };

    const handleShareableLink = async () => {
        if (
            typeof window !== "undefined" &&
            window.navigator &&
            window.location
        ) {
            try {
                // Chrome clipboard
                await window.navigator.clipboard.writeText(
                    window.location.href
                );
                await shareLink(listing, property);
            } catch (e) {
                try {
                    if (typeof ClipboardItem === "function") {
                        // Safari clipboard
                        await window.navigator.clipboard.write([
                            clipboardItemWrite(),
                        ]);
                    }
                } catch (e) {}
            }

            setIsCopied(true);

            setTimeout(async () => {
                setIsCopied(false);
            }, 3000);
        }
    };

    let isOpen = true;
    let address, cityName;
    let price = null;

    if (listing) {
        address = listing.address;
        cityName = listing.city.name + ", " + listing.state.abbr;
        price = moneyFormatter(0).format(listing.price);
    } else if (property) {
        address = property.address;
        cityName = property.city.name + ", " + property.state.abbr;
    } else {
        isOpen = false;
    }

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onClose}
            className={css.modal}
            ariaHideApp={false}
        >
            <div className={css.modalContent}>
                <div className={css.logo}>
                    <Logo size="lg" />
                </div>

                <CloseIcon onClick={onClose} className={css.close} />

                <form onSubmit={handleSubmit}>
                    <div className={css.header}>
                        <div className={css.headerLeft}>
                            Email
                            <br />
                            this Home
                        </div>
                        <div
                            className={classNames({
                                [css.headerRight]: true,
                                [cssModal.headerRight]: true,
                            })}
                        >
                            <div>{address}</div>
                            <strong>{cityName}</strong>
                            <br />
                            {price && <div>{price}</div>}
                        </div>
                    </div>

                    <div className={css.line} />

                    <div className={cssModal.role}>
                        <div className={cssModal.group}>
                            <label>Recipient's email</label>
                            <div className={cssModal.inputGroup}>
                                <Field
                                    type="email"
                                    inputMode="email"
                                    autoComplete="email"
                                    id="share_recipient_email"
                                    name="recipient_emails"
                                    placeholder="Enter email"
                                    className={formCss.input}
                                />
                                <ErrorMessage
                                    name="recipient_emails"
                                    component="div"
                                    className={formCss.error}
                                />
                            </div>
                            <div className={cssModal.help}>
                                You can separate 2 email addresses with a comma
                            </div>
                        </div>
                    </div>

                    <div className={cssModal.role}>
                        <div className={cssModal.group}>
                            <label>Your email</label>
                            <div className={cssModal.inputGroup}>
                                <Field
                                    type="email"
                                    inputMode="email"
                                    autoComplete="email"
                                    id="share_email"
                                    name="sender_email"
                                    placeholder="Enter email"
                                    className={formCss.input}
                                />
                                <ErrorMessage
                                    name="sender_email"
                                    component="div"
                                    className={formCss.error}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={cssModal.role}>
                        <div className={cssModal.group}>
                            <label>Include message (optional)</label>
                            <div className={cssModal.inputGroup}>
                                <Field
                                    inputMode="text"
                                    name="message"
                                    value={values.message}
                                    component="textarea"
                                    rows={4}
                                    maxLength={1000}
                                    className={cssModal.textarea}
                                />
                                <ErrorMessage
                                    name="message"
                                    component="div"
                                    className={cssModal.error}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={cssModal.buttons}>
                        <div className={cssModal.buttonLeft}>
                            <button
                                type="submit"
                                className={
                                    isSubmitting
                                        ? cssModal.submitting
                                        : cssModal.submit
                                }
                                disabled={isSubmitting}
                                onClick={handleSubmit}
                            >
                                {isSubmitting ? "Please wait..." : "SEND EMAIL"}
                            </button>
                        </div>

                        <div className={cssModal.buttonRight}>
                            {!isCopied && (
                                <button
                                    type="button"
                                    className={cssModal.buttonLink}
                                    onClick={handleShareableLink}
                                >
                                    Get Shareable Link
                                </button>
                            )}
                            {isCopied && (
                                <div className={cssModal.copied}>
                                    Link copied to clipboard
                                </div>
                            )}
                        </div>
                    </div>
                </form>
            </div>
        </ReactModal>
    );
};

Share.propTypes = {
    listing: PropTypes.object,
    property: PropTypes.object,
    onSuccess: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};

const formikForm = withFormik({
    enableReinitialize: true,
    handleSubmit: async (values, { setSubmitting, setErrors, props }) => {
        const { listing, property, onSuccess } = props;
        const data = clone(values);

        try {
            if (listing) {
                data.listing = listing.id;

                await shareListing(data);
            } else {
                data.property = property.url;

                await shareProperty(data);
            }

            toastInfo("Email sent successfully.");

            onSuccess();
        } catch (e) {
            setErrors(getFormErrors(e));

            toastError("Something is wrong.");
        }

        setSubmitting(false);
    },
    mapPropsToValues: (props) => {
        const { listing, property } = props;

        let cityName = "...";

        if (listing) {
            cityName = listing.city.name + ", " + listing.state.abbr;
        } else if (property) {
            cityName = property.city.name + ", " + property.state.abbr;
        }

        return {
            recipient_emails: "",
            sender_email: "",
            message:
                "Check out this home I found in " +
                cityName +
                " on Residential.com",
        };
    },
    validationSchema: ValidationSchema,
})(Share);

export default formikForm;
